module.exports = __webpack_public_path__ + "img/IT0000569758730.232fda16.png";